import React, { useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

import SessionContext from "../helpers/SessionContext"
import UserMenu from "./UserMenu"

const Header = () => {
  const { session } = useContext(SessionContext)
  const [isVisible, setIsVisible] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === "/") {
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 3000)
      return () => clearTimeout(timer)
    } else {
      setIsVisible(true)
    }
  }, [location.pathname])

  return (
    <div className={`bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 fixed top-0 w-full z-50 transition-transform duration-700 ease-in-out ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
      <header className="bg-gray-900/70 backdrop-blur-lg border-b border-white/10 shadow-lg">
        <div className="w-full px-4 py-1">
          <div className="flex items-center w-full">
            <div className="flex items-center">
              <a className="flex items-center" href="/">
                <img
                  alt="Smartrocks Logo"
                  className="h-20"
                  src={require("../images/SR_Icon_Horizontal_White_Transparent.png")}
                />
              </a>
            </div>

            {session ? (
              <nav className="flex items-center justify-end space-x-6 flex-1">
                <a
                  className="text-white hover:text-slate-900 dark:text-slate-300 dark:hover:text-white font-medium"
                  href="/projects"
                >
                  Dashboard
                </a>
                <UserMenu />
              </nav>
            ) : (
              <nav className="flex items-center justify-end space-x-6 flex-1">
                <a
                  className="text-white hover:text-slate-900 dark:text-slate-300 dark:hover:text-white font-medium"
                  href="/#contact-form"
                >
                  Contact us
                </a>
                <a
                  className="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-4 py-2 rounded"
                  href="/login"
                >
                  Log In
                </a>
              </nav>
            )}
          </div>
        </div>
      </header>
    </div>
  )
}

export default Header
